import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import Glyph from '../core/Glyph';
import {LabelSmallText} from '../core/Type';

export default class Tree extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            treeView: {
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                paddingTop: CoreMetrics.ElementPadding.XSmall(),
                paddingBottom: CoreMetrics.ElementPadding.XSmall(),
                paddingLeft: 0,
                paddingRight: 0,
            },
        });

        let combinedStyles = [styles.treeView];
        if (this.props.styles != null) {
            combinedStyles = combinedStyles.concat(this.props.styles);
        }

        return (
            <div className={css(combinedStyles)}>
                <TreeRow level={0} title="All content" />
                <TreeRow level={1} title="Math" />
                <TreeRow level={2} title="AP Calculus AB" />
                <TreeRow level={3} title="Derivatives introduction" />
                <TreeRow level={4} title="Estimating derivatives with secant lines and average rate of change" />
                <TreeRow level={5} title="Secant lines & average rate of change" />
                <TreeRow level={1} title="Physics" />
                <TreeRow level={2} title="One-dimensional motion" />
                <TreeRow level={3} title="Displacement, velocity, and time" />
                <TreeRow level={4} title="Average velocity and average speed" />
            </div>
        );
    }
}

class TreeRow extends React.Component {
    render() {
        const level = this.props.level;
        const title = this.props.title;
        const indentationPerLevel = 24;

        const styles = createExpandableMediaQueryStylesheet({
            treeRow: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                // height: CoreMetrics.ElementHeight.XSmall(),
                paddingTop: CoreMetrics.ElementPadding.XXSmall(),
                paddingBottom: CoreMetrics.ElementPadding.XXSmall(),
                paddingLeft: CoreMetrics.ElementPadding.Medium(),
                paddingRight: CoreMetrics.ElementPadding.Medium(),
            },
            caret: {
                marginRight: CoreMetrics.ElementSpacing.XSmall(),
                marginLeft: level * indentationPerLevel,
            },
            expanded: {
            },
        });

        return (
            <div className={css(styles.treeRow)}>
                <Glyph styles={[styles.caret]} asset="assets/12x12-chevron.svg" size={Glyph.Size.XSmall} fillColor={CoreMetrics.Color.Neutral.OffBlack} />
                <LabelSmallText>{title}</LabelSmallText>
            </div>
        );
    }
}
TreeRow.defaultProps = {
    level: 0,
    expanded: true,
    icon: null,
    title: "Node",
};



// WEBPACK FOOTER //
// ./src/layouts/Tree.jsx